<div class="form-container flex flex-row full-grow-no-shrink-no-basis " >
  <div  class="translate-document w-p-100 flex flex-col full-grow-no-shrink-no-basis ">
    <div class="header flex flex-row justify-between items-center">
      <div class="title" *ngIf="formModel && formModel.hasPreview">
        <span
          *ngIf="translationModel.toolName === translationToolNames.Translation || translationModel.toolName === translationToolNames.ConvertCurrency">Revised Document <span
          *ngIf="formModel.languageText">({{formModel.languageText}})</span></span>
        <span *ngIf="translationModel.toolName === translationToolNames.Compare">{{formModel.fileName}}<span
          *ngIf="formModel.languageText">({{formModel.languageText}})</span></span>
      </div>
      <div class="button-container m-r-20 flex flex-row justify-start items-center"
           *ngIf="formModel && formModel.hasPreview">
        <div class="flex flex-row justify-start items-center">
          <button [disabled]="!isIFrameDirty" mat-button class="grid-button header-button h-n-28 flex flex-row justify-start items-center"
                  (click)="onSaveFxRateChanges()" data-copilot="viewer-btn-save-changes">
            <i class="far fa-check m-l-5"></i>
            Save Changes
          </button>
          <div class="flex flex-row justify-start items-center">
            <span class="title">Page</span>
            <select [value]="formModel.currentPage" (change)="jumpToPage($event)" data-copilot="viewer-select-translated-page">
              <option *ngFor="let page of formModel?.pages; let i =index;" [value]="i+1">{{i + 1}}</option>
            </select>
          </div>

        </div>
      </div>
    </div>


    <!--    <div class="navigaion-section" fxLayoutAlign="center start" fxLayout="column">
          <div class="top p-20 w-p-100" fxLayout="row" fxLayoutAlign="space-between center"
               *ngIf="formModel && formModel.hasPreview">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="title"><a class="link-color" (click)="onDownload()">{{formModel?.fileName}}</a>
              </div>
            </div>

            <div class="navigaion-panle" fxLayout="row" fxLayoutAlign="start center">
            </div>
          </div>
          <div class="notification-message" fxLayout="row"
               *ngIf="formModel && formModel.htmlFileId">
          </div>
          <div class="top p-20 w-p-100" fxLayoutAlign="space-between center" *ngIf="formModel && !formModel.hasPreview">
            <div class="title">
              {{progressStatus.status}}<span *ngIf="progressStatus.percentage>0">: {{progressStatus.percentage}}%</span>
            </div>
          </div>
        </div>-->
    <div  class="flex flex-row full-grow-no-shrink-no-basis " *ngIf="iFrameContent !== null"
         data-copilot="viewer-translated-document"
         [innerHTML]="iFrameContent  | sanitizeHtml">
    </div>
    <div  class="flex flex-row full-grow-no-shrink-no-basis " *ngIf="iFrameContent === null && progressStatus.message">
      {{progressStatus.message}}
    </div>
  </div>
  <div class="fxSelector" style="padding: 10px;">
    <div>
      <div id="demandConvert" class="onDemandConvert" style="margin-bottom: 6px;"></div>
      <button (click)="convertFx()" mat-button class="action-button" data-copilot="viewer-btn-accept-amount"><i class="fa fa-check" style="color: green;"></i>
      </button>
      <button (click)="revertFxConversion()" mat-button class="action-button" data-copilot="viewer-btn-revert-amount"><i class="fa fa-reply"
                                                                                 style="color: #494949;"></i></button>

    </div>
  </div>

  <div id="" class="currencySymbolSelector" style="padding: 10px;">
    <div>
      <div class="onDemandCurrencySymbol" style="margin-bottom: 6px;"></div>
      <button (click)="convertCurrencySymbol()" mat-button class="action-button" data-copilot="viewer-btn-accept-symbol"><i class="fa fa-check"
                                                                                    style="color: green;"></i></button>
      <button (click)="revertCurrencySymbol()" mat-button class="action-button" data-copilot="viewer-btn-revert-symbol">
        <i class="fa fa-reply" style="color: #494949;"></i>
      </button>

    </div>
  </div>
